import { IStore } from "redux/reducers/types";
import { createSelector } from "reselect";

const getError = (state: IStore) => state.error;

const getErrorSelector = () => createSelector([getError], (error) => error);

export default getErrorSelector;
